import { reduxForm, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import compose from 'lodash/fp/compose';

import { REDUCER_NAME } from 'src/reducers/reports/notificationOfBaseAmountRevisions';
import { getErrors } from 'src/reducers/common/listReducer';
import {
  takeNotificationOfBaseAmountSearchQueriesFromLocation,
  notificationOfBaseAmountMonthsSearchFormSelector,
  FORM_NAME_NOTIFICATION_OF_BASE_AMOUNT_MONTHS_SEARCH
} from 'src/reducers/searchForm';
import ShowRevisions from '../components/ShowRevisions';

const mapStateToProps = state => ({
  initialValues: {
    ...takeNotificationOfBaseAmountSearchQueriesFromLocation(state.router.location),
    ...getFormValues(FORM_NAME_NOTIFICATION_OF_BASE_AMOUNT_MONTHS_SEARCH)(state)
  },
  yearMonth: notificationOfBaseAmountMonthsSearchFormSelector(state, 'yearMonth'),
  location: state.router.location,
  errors: getErrors(REDUCER_NAME, state)
});

export default compose(
  connect(mapStateToProps),
  reduxForm({
    form: FORM_NAME_NOTIFICATION_OF_BASE_AMOUNT_MONTHS_SEARCH,
    enableReinitialize: true
  })
)(ShowRevisions);
